import React from 'react';
import "./MessageContent.scss";
import { Label } from 'src/ui';
import { localize } from 'src/l10n';
import { formatInteractiveText } from 'src/utils';
import MessageAttachments from '../MessageAttachments/MessageAttachments';
import MessageObjects from '../MessageObjects/MessageObjects';
import MemoHeader from '../MemoHeader/MemoHeader';
import MessageLinkCard from '../MessageLinkCard/MessageLinkCard';
import useMessageLinkCard from '../MessageLinkCard/useMessageLinkCard';

interface IProps {
    message: Spintr.IChatMessage;
    isParent?: boolean;
}

const MessageContent = (props: IProps) => {
    // Reply previews stay compact and show no card, and neither do messages
    // whose author dismissed it. Undefined counts as shown, so messages
    // predating the flag - and any client that doesn't send it - keep a card.
    const cardIsHidden = props.isParent ||
        props.message.isDeleted ||
        props.message.displayBookmark === false;

    const linkCardMetadata = useMessageLinkCard(cardIsHidden ? "" : props.message.text);

    if (props.message.isDeleted) {
        return (
            <div className={"MessageContent deleted"}>
                <Label
                    color="grey"
                    italic
                    className="interactive-text general-row-break deleted-placeholder">
                    {localize("CHAT_MESSAGE_DELETED")}
                </Label>
            </div>
        );
    }

    return (
        <div className={"MessageContent"}>
            {props.message.isMemo && (
                <MemoHeader memoTitle={props.message.memoTitle} />
            )}
            {props.message.text && (
                <Label
                    className="interactive-text general-row-break">
                    {formatInteractiveText(props.message.text)}
                </Label>
            )}
            {linkCardMetadata && (
                <MessageLinkCard metadata={linkCardMetadata} />
            )}
            <MessageObjects message={props.message} />
            <MessageAttachments message={props.message} isParent={props.isParent} />
        </div>
    )
}

export default MessageContent;
